import type { KeycloakInitOptions } from "keycloak-js";

/** Authenticated app bootstrap — visitors on `/visit/consent/:token` skip Keycloak entirely. */
export const authenticatedKeycloakInitOptions: KeycloakInitOptions = {
  checkLoginIframe: true,
  onLoad: "login-required",
  silentCheckSsoFallback: true
};
